<script setup lang="ts">
import { debounce } from '@daysmart/daysmart-vue-components/utils'
import theme from './theme'

const route = useRoute()
const { isWidget } = useWidgetSettings()
useLocale() // configure global locale watcher

const title = computed(() => {
  const title = route?.meta?.title
  if (title)
    return `${title} | TeamUp`

  return 'TeamUp'
})
// useHead({
//   title,
//   meta: [
//     {
//       name: 'description',
//       content: 'Simple, powerful management software for fitness businesses',
//     },
//   ],
// })
//   // base: {
//   //   href: import.meta.env.DEV ? 'http://localhost:4000' : '',
//   // },

const debouncedOnResize = debounce((height) => {
  if (height > 0) {
    // window.parent?.teamupSocket?.setHeight(height + 30) // old method
    TEAMUP_WIDGET_HELPER?.setHeight(height, true) // new method
  }
}, 500, { maxWaitMs: 1000 })

if (isWidget) {
  useElementHeight('#content-wrapper', {
    onResize: debouncedOnResize,
  })
}
onMounted(() => {
  if (!isWidget) {
    document.getElementById('app')?.classList.add('overscroll-none')
  }
})
</script>

<template>
  <div
    id="content-wrapper"
    :class="{ 'has-app-gradient': !isWidget }"
  >
    <ProviderThemeCssVariables />
    <DSThemeProvider :theme="theme" />
    <router-view :key="route.fullPath" />
    <DSNotifier class="fixed bottom-10 right-10 z-toast w-300px" />
    <AppAlerts />
    <DSModalsContainer />
  </div>
</template>

<style lang="scss">
html,
body,
#app {
  height: 100%;
  padding: 0;
  margin: 0;
  text-underline-offset: 2px;
  @apply font-theme;

  &:has(.has-app-gradient) {
    @apply bg-gradient-to-b from-white from-10% via-secondary via-50% to-secondary;
  }
}

* {
  &:focus {
    @apply outline-none;
  }
  &:focus-visible {
    @apply lt-sm:outline-none sm:outline-8 sm:outline-offset-1 sm:outline-primary;
    // TODO: get hacky to display a floating box around that isn't affected by overflow: hidden
    // maybe look into how screen readers do it
    // @apply ring-8 ring-offset-1 ring-offset-transparent ring-brand outline-none;
  }
}

.touch-target {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    z-index: 1;
    width: 48px;
    height: 48px;
    //background: #f09;
  }
}

.link {
  &:hover {
    text-decoration: underline;
  }
}
</style>
